export default __webpack_public_path__ + "static/Spitz_Germany_banner_mobile-f79bfd17c0adecb9f1dbd52f095be59d.jpg";